<div class="phone">
  <div class="phone-frame"></div>
  <div class="screen-content-container">
    <ng-content></ng-content>
  </div>
</div>
